import { useMutation, useQuery } from '@tanstack/react-query';
import { IAddress } from 'models/Address';
import {
  createAddress,
  createBillingAddress,
  getAddresses,
} from './address.api';
import { Address } from '../../models/address.types';
import { useAuth } from '../../contexts/AuthContext';

export const useCreateAddressMutation = () => useMutation({
  mutationFn: async (address: IAddress) => createAddress(address),
  onSuccess: (response) => response,
});

export const useCreateBillingAddress = () => useMutation({
  mutationFn: async (address: Address) => createBillingAddress(address),
  onSuccess: (response) => response,
});

export const useFetchAddressesForLoggedout = () => useQuery({
  queryKey: ['fetch-addresses'],
  queryFn: async () => getAddresses(),
});

export const useFetchAddresses = () => {
  const { isLoggedIn } = useAuth();
  return useQuery({
    queryKey: ['fetch-addresses'],
    queryFn: async () => getAddresses(),
    enabled: isLoggedIn,
  });
};
